import React from 'react';
import { MailIcon, PhoneIcon } from '@heroicons/react/solid'
import ProfilePicture from '../App/ProfilePicture';



function DentistCard({dentist, setPickedDentist, pickedDentist}) {

  const pickDentist= () => {
    if(pickedDentist===dentist){
      setPickedDentist(null)
    } else {
      setPickedDentist(dentist);
    }
  }


  return (
    
      <li key={dentist.email} className={`bg-white hover:bg-blue-50 cursor-pointer border rounded-lg shadow divide-y divide-gray-200 ${pickedDentist?._id === dentist?._id && "border-2 border-primary"}`} onClick={() =>{pickDentist()}}>
        <div className="w-full flex items-center justify-between p-2 md:p-6">
          <div className="flex-1 truncate">
            <div className="flex items-center space-x-3">
              <h3 className="text-gray-900 text-sm font-medium truncate">{dentist.user_id.first_name} {dentist.user_id.last_name}</h3>
            </div>
            <p className="mt-1 text-gray-500 text-sm truncate">{dentist.type || "Partner"}</p>
          </div>
          <ProfilePicture user={dentist.user_id}/>
        </div>
        <div>
          <div className="flex flex-col divide-y divide-gray-200">
            <div className="flex-1 flex py-1">
                <MailIcon className="ml-2 w-5 h-5 text-gray-400" aria-hidden="true" />
                <span className="ml-3">{dentist.user_id.email}</span>
            </div>
            <div className="flex-1 flex py-1">
                <PhoneIcon className="ml-2 w-5 h-5 text-gray-400" aria-hidden="true" />
                <span className="ml-3">{dentist.user_id.mobile_nb}</span>
            </div>
          </div>
        </div>
      </li>
  )
}
export default DentistCard;
